const FONT = '"Public Sans", sans-serif';

function hexToRgba(hex, alpha) {
  const h = String(hex || '#8e8e93').replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default function BadgedMetricas({ color, label, value, icon: Icon }) {
  const tint = color || '#8e8e93';

  return (
    <div
      className="inline-flex items-center gap-2 shrink-0 h-9 pl-1.5 pr-3 rounded-full"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        whiteSpace: 'nowrap',
        fontFamily: FONT,
      }}
    >
      {Icon && (
        <span
          className="flex items-center justify-center shrink-0 w-6 h-6 rounded-full"
          style={{ backgroundColor: hexToRgba(tint, 0.14) }}
        >
          <Icon size={13} color={tint} />
        </span>
      )}
      <span
        style={{
          fontSize: '13px',
          lineHeight: '16px',
          fontWeight: 600,
          color: 'rgba(255, 255, 255, 0.92)',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </span>
      <span
        style={{
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 500,
          color: 'rgba(255, 255, 255, 0.45)',
        }}
      >
        {label}
      </span>
    </div>
  );
}
